module.exports = __webpack_public_path__ + "static/media/home-exercising.7bc43633.svg";